import { format, parse, startOfDay } from 'date-fns/fp';

import { lensPath, over, curry } from 'ramda';

/**
 * Date format while in the app.
 */
export const dobFormat = 'MM/dd/yyyy';
/**
 * Date format to send to and receive from the API.
 */
export const apiDoBFormat = 'yyyy-MM-dd';

export const parseStringAsDate = curry(
  (format: string, value: string): Date => {
    return startOfDay(parse(startOfDay(new Date()), format, value));
  },
);

export const parseDoB = parseStringAsDate(dobFormat);

export const parseApiDob = parseStringAsDate(apiDoBFormat);

const reformatDate = curry(
  (fromFormat: string, toFormat: string, date: string | null) => {
    return date ? format(toFormat, parseStringAsDate(fromFormat, date)) : date;
  },
);

/**
 * Transform a date at a path from one format to another.
 */
export const transformDate = <T>(
  fromFormat: string,
  toFormat: string,
  path: string[],
  obj: T,
): T => {
  const lens = lensPath(path);
  return over(lens, reformatDate(fromFormat, toFormat), obj);
};

export const transformDob = <T>(path: string[], params: T): T => {
  return transformDate(dobFormat, apiDoBFormat, path, params);
};

export const transformDobFromApi = <T>(path: string[], params: T): T => {
  return transformDate(apiDoBFormat, dobFormat, path, params);
};
